export const LOGIN_USER = 'account.LOGIN_USER';
export const LOGOUT_USER = 'account.LOGOUT_USER';
export const USER_DOTASK = 'account.USER_DOTASK';
